import {
  buildUserPayload,
  clockInRequest,
  ensureClockInUser,
  normalizeMaterial
} from './client'

export async function submitMaterial(payload = {}) {
  const res = await clockInRequest({
    url: '/postMaterial',
    method: 'POST',
    data: buildUserPayload({
      Content: payload.content || '',
      ImageUrls: payload.image_urls || []
    })
  })
  return normalizeMaterial(res.data || {})
}

export async function getMyMaterials(params = {}) {
  const user = ensureClockInUser()
  const res = await clockInRequest({
    url: '/getMyMaterialList',
    method: 'GET',
    params: {
      UserId: user.id,
      page: params.page || 1,
      pageSize: params.pageSize || 50
    }
  })
  return (res.data || []).map(normalizeMaterial)
}